export default {
  CLEAR_NOTIFICATION: 'CLEAR_NOTIFICATION',
  SET_NOTIFICATION: 'SET_NOTIFICATION',
  SET_CALLBACK: 'SET_CALLBACK',
  SET_TERMINAL_NOTIFICATION: 'SET_TERMINAL_NOTIFICATION',
  CLEAR_TERMINAL_NOTIFICATION: 'CLEAR_TERMINAL_NOTIFICATION',
};
